export const USERDATAENDPOINT = "/careroutes/user-capture/";
